import { SupabaseProviderConfig } from '../types/supabase';

import { authConfig } from '@/config';

export const SUPABASE_PROVIDERS: SupabaseProviderConfig[] = [
  {
    id: 'default',
    supabaseUrl: authConfig.supabase.url,
    anonKey: authConfig.supabase.key,
    isDefault: true,
  },
  {
    id: 'tnkdjgksnlhhaaxgdmdj-solenis',
    supabaseUrl: 'https://tnkdjgksnlhhaaxgdmdj.supabase.co',
    anonKey: 'sb_publishable_Qodk-EZribG_0fCS4o-Z8g_1FxBTZwJ',
    ssoClient: true,
    ssoValidDomains: ['solenis.adds.sl', 'solenis.com', 'contractor.solenis.com'],
    ssoProvider: [{ id: '12140c11-4cc4-4aac-ac70-7a827e27e1c8', label: 'Solenis' }],
  },
];
